import { useState } from "react";

const WelcomeModal = ({ isOpen, templates, onComplete, onDismiss }) => {
  const [step, setStep] = useState(1);
  const [openImport, setOpenImport] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  if (!isOpen) return null;

  const handlePathSelect = (path) => {
    setOpenImport(path === "import");
    setStep(2);
  };

  const handleTemplateSelect = (templateId) => {
    onComplete(templateId, openImport);
  };

  const handleDismiss = () => {
    setStep(1);
    setOpenImport(false);
    onDismiss(dontShowAgain);
  };

  return (
    <div
      className="pcm-modal-overlay"
      data-testid="welcome-modal-overlay"
      onClick={handleDismiss}
    >
      <div
        className="pcm-modal pcm-welcome-modal"
        data-testid="welcome-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {step === 1 ? (
          <>
            <div className="pcm-modal-header">
              <div className="pcm-welcome-heading">
                <h2 className="pcm-modal-title" data-testid="welcome-title">
                  Welcome to Context Savior
                </h2>
                <p className="pcm-welcome-subtitle">
                  Keep your AI projects organised. How do you want to start?
                </p>
              </div>
              <button
                type="button"
                className="pcm-modal-close"
                onClick={handleDismiss}
                data-testid="welcome-close-button"
              >
                ✕
              </button>
            </div>

            <div className="pcm-welcome-cards" data-testid="welcome-cards">
              <button
                type="button"
                className="pcm-welcome-card"
                onClick={() => handlePathSelect("import")}
                data-testid="welcome-import-card"
              >
                <span className="pcm-welcome-card-icon" aria-hidden>✨</span>
                <span className="pcm-welcome-card-label">Import an AI conversation</span>
                <span className="pcm-welcome-card-desc">
                  Already chatting with Claude, ChatGPT, or another AI? Paste
                  your conversation and we'll extract your project context
                  automatically. You'll need a free API key to use this feature.
                </span>
              </button>

              <button
                type="button"
                className="pcm-welcome-card"
                onClick={() => handlePathSelect("fresh")}
                data-testid="welcome-fresh-card"
              >
                <span className="pcm-welcome-card-icon" aria-hidden>📝</span>
                <span className="pcm-welcome-card-label">Start a fresh project</span>
                <span className="pcm-welcome-card-desc">
                  Know what you're working on? Fill in the template manually. No
                  API key needed to get started.
                </span>
              </button>
            </div>

            <label className="pcm-welcome-dismiss" data-testid="welcome-dismiss-label">
              <input
                type="checkbox"
                className="pcm-welcome-checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                data-testid="welcome-dont-show-checkbox"
              />
              Don't show this again
            </label>
          </>
        ) : (
          <>
            <div className="pcm-modal-header">
              <div className="pcm-welcome-heading">
                <button
                  type="button"
                  className="pcm-welcome-back"
                  onClick={() => setStep(1)}
                  data-testid="welcome-back-button"
                >
                  ← Back
                </button>
                <h2 className="pcm-modal-title" data-testid="welcome-template-title">
                  Choose a starting template for your first project
                </h2>
              </div>
              <button
                type="button"
                className="pcm-modal-close"
                onClick={handleDismiss}
                data-testid="welcome-close-button"
              >
                ✕
              </button>
            </div>

            <div className="pcm-template-grid" data-testid="welcome-template-grid">
              {templates.map((template) => (
                <button
                  key={template.id}
                  type="button"
                  className="pcm-template-card"
                  onClick={() => handleTemplateSelect(template.id)}
                  data-testid={`welcome-template-${template.id}`}
                >
                  <span className="pcm-template-label">{template.label}</span>
                  <span className="pcm-template-desc">{template.description}</span>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WelcomeModal;
